import { depenses } from './api';

// Compression côté client, « au dessin » : le redimensionnement (≤ 1600 px)
// est fait au drawImage, jamais d'aller-retour dataURL 12 Mpx (patron de la
// PWA parking). createImageBitmap applique l'orientation EXIF.
const COTE_MAX = 1600;
const QUALITE = 0.85;

export async function compresserImage(file) {
  if (file.type === 'application/pdf') return file;
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const ratio = Math.min(1, COTE_MAX / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * ratio);
    canvas.height = Math.round(bitmap.height * ratio);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITE));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    // Navigateur sans createImageBitmap : le fichier part tel quel (le serveur
    // plafonne à 20 Mo).
    return file;
  }
}

// Presign → PUT direct sur le stockage → création de la dépense (l'octet ne
// traverse jamais le backend). Renvoie l'id de la dépense créée.
export async function televerserJustificatif(fichier, dossierId) {
  const file = await compresserImage(fichier);
  const presign = await depenses.presign({
    filename: file.name,
    content_type: file.type,
    size: file.size,
  });
  const { uploadUrl, key } = presign.data;
  const put = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!put.ok) throw new Error(`Échec de l'envoi du fichier (${put.status})`);
  const creation = await depenses.creer({ justificatif_key: key, dossier_id: dossierId ?? null });
  return creation.data.id;
}
